import React from "react";
import { PhoneCall } from "lucide-react";

import { tr } from "../i18n";
export const CALLBACK_SLOTS = ["Morning (9:00–12:00)", "Midday (12:00–15:00)", "Afternoon (15:00–18:00)"];

export default function CallbackFields({ form, setForm }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div className="rounded-2xl bg-white/5 ring-1 ring-white/10 p-4">
      <label className="flex items-center gap-3 cursor-pointer text-white text-[14px]">
        <input type="checkbox" data-testid="callback-toggle" checked={form.callbackRequested}
          onChange={(e) => setForm({ ...form, callbackRequested: e.target.checked })}
          className="w-4 h-4 accent-[#c2a15a]" />
        <PhoneCall size={16} className="text-[#c2a15a]" /> {tr("Request a callback")}
      </label>
      {form.callbackRequested && (
        <div className="grid sm:grid-cols-3 gap-3 mt-4">
          <select required data-testid="callback-region-select" value={form.callbackRegion}
            onChange={set("callbackRegion")} className="rh-input" aria-label={tr("Region")}>
            <option value="United Kingdom">{tr("United Kingdom")}</option>
            <option value="Germany">{tr("Germany")}</option>
            <option value="Austria">{tr("Austria")}</option>
            <option value="Switzerland">{tr("Switzerland")}</option>
          </select>
          <input required type="date" min={today} data-testid="callback-date-input" value={form.callbackDate}
            onChange={set("callbackDate")} className="rh-input" aria-label={tr("Preferred day")} />
          <select required data-testid="callback-time-select" value={form.callbackTime}
            onChange={set("callbackTime")} className="rh-input" aria-label={tr("Preferred time")}>
            {CALLBACK_SLOTS.map((s) => <option key={s} value={s}>{tr(s)}</option>)}
          </select>
          <p className="sm:col-span-3 text-[12px] text-white/50">
            {tr("Times refer to the selected region's local time.")}
          </p>
        </div>
      )}
    </div>
  );
}
